import { AI_DOMAIN_URL, API_BASE_URL } from "./site_urls"
export const STORAGE = "plan-crafter"
export const STORAGE_VERSION = "202408131509"
export const DEFAULT_COUNTRY_ID = process.env.REACT_APP_DEFAULT_COUNTRY_ID || '4'
export const SITE_URL = process.env.REACT_APP_SITE_URL;
// console.log("SITE_URL", SITE_URL, DEFAULT_COUNTRY_ID)
// 'https://plancrafter-ui.dreamztesting.com'
// 'https://www.plancrafter.tech'

export const URLS = {
    HOME: "/",
    LOGIN: "/login",
    SIGN_UP: "/sign-up",
    EMAIL_LOGIN: "/email-login",
    OTP: "/otp",
    LOGOUT: "/logout",
    SUBSCRIPTION: "/subscription",
    ADDONS: "/addons/:subscriptionId",

    BUSINESS_PLAN: "/business-plan/:subscriptionId",
    PAYMENT_METHOD: "/payment-method",
    THANKYOU_PAGE: "/thank-you",
    AI_ASSISTANCE_ANS: "/ai-assistance-ans",

    APPROVE_OR_REJECT: "/info",

    MARKETER: {
        COMMISSION_HISTORY: "/marketer/commission-history",
        CUSTOMERS: "/marketer/customers",
    },

    ACCOUNT: {
        MY_ACCOUNT: "/account/profile",
        MY_BUSINESS_PLAN: "/account/my-business-plan",
        MY_BUSINESS_PLAN_DETAILS: "/account/my-business-plan-details/:proposalId",
        PAYMENT: {
            PRICE_DETAILS: "/account/price-details/:proposalId",
            PAY: "/account/payment/:proposalId",
            THANK_YOU: "/account/payment-thank-you",
        },

        TICKET: {
            LIST: "/account/tickets",
            CREATE: "/account/ticket-create",
            REPLY: "/account/ticket-details/:ticketId",
        }
    },

    PAYMENT: {
        PAY: "/pay",
    },

    CMS_PAGES: {
        CMS_LINK: "/:cmsSlug",
        ABOUT_US: "/about",
        CONTACT_US: "/contact-us"
    },

    MENU_PAGES: {
        PAGE_DETAILS: "/page/:pageSlug", 
        PAGE_DETAILS_DYNAMIC_CAT: "/:country/:catSlug",
        PAGE_DETAILS_DYNAMIC_CHILD: "/:country/:catSlug/:pageSlug",
        PAGE_DETAILS_DYNAMIC_PAGE: "/:country/:catSlug/:childCatSlug/:pageSlug/", 
    },

    BLOG_NEWS: {
        LIST: "/blog-and-news",
        NEWS_DETAILS: `/news/:slug`,
        BLOG_DETAILS: `/blog/:slug`, 
    },
    
    NOT_FOUND: "/not-found",
}

/**
 * Route path prefixes that must be served as `noindex, follow` (see public/robots.txt
 * Disallow rules). Sole runtime consumer: src/components/RouteMeta.tsx.
 * Matching is prefix-based: `pathname === prefix || pathname.startsWith(prefix + '/')`.
 *
 * Defensive/no-op entries kept intentionally (currently match no real route):
 *   '/admin'         — the separate Laravel Blade admin panel; not part of this SPA's
 *                       router (no <Route> in App.tsx). Kept in sync with robots.txt.
 *   '/dashboard'     — no matching <Route> currently exists in App.tsx/URLS.
 *   '/questionnaire' — same; kept for forward-compatibility with robots.txt.
 */
export const PRIVATE_ROUTE_PREFIXES = [
    '/login', '/email-login', '/sign-up', '/otp', '/logout',
    '/subscription', '/addons', '/business-plan', '/thank-you',
    '/ai-assistance-ans', '/payment-method', '/pay', '/info', '/account',
    '/admin', '/dashboard', '/questionnaire',
];

// Public marketing routes safe to prerender (react-snap) and list in sitemap.xml.
// This is a REFERENCE copy for discoverability — the two operational copies actually
// read at build time must be kept in sync with this list and each other:
//   - package.json → reactSnap.include
//   - scripts/generate-sitemap.js → STATIC_ROUTES
// (Neither can import this TS file: package.json is plain JSON with no imports, and
// generate-sitemap.js runs as a plain `node` script with no TS/Babel loader configured.)
export const PUBLIC_STATIC_ROUTES = ['/', '/about', '/contact-us', '/blog-and-news'];


export const API_URL = {
    HOME_CONTENT_DATA: `${API_BASE_URL}/home-content?page=`,
    SOCIAL_DETAILS: `${API_BASE_URL}/social-details`,
    GENERAL_INFO: {
        COUNTRY_LIST: `${API_BASE_URL}/get-countries`,
        MENU_LIST: (countryId:string) =>  `${API_BASE_URL}/get-menus?country_id=${countryId}`, // ?country_id=1
    },

    SUBSCRIPTION: {
        // PLAN_LIST: `https://dummy.restapiexample.com/api/v1/employees`,
        PLAN_TYPE_LIST: `${API_BASE_URL}/subscription-plan-types`,  // For Home page
        PLAN_LIST: `${API_BASE_URL}/subscription-plans`,
    },

    ADD_ONS: {
        LIST: `${API_BASE_URL}/addons`,
    },

    BUSINESS_PLAN: {
        QUESTIONNAIRE: `${API_BASE_URL}/questionnaire`,
        PROPOSAL_CREATE: `${API_BASE_URL}/proposal/create`,
        PROPOSAL_UPDATE: `${API_BASE_URL}/proposal/update`,

        // AI_SUGGESTION: `https://plancraftai-dev.dreamztesting.com/api/v1/prompt/ai-suggestion`,
        AI_SUGGESTION: `${AI_DOMAIN_URL}/api/v1/prompt/ai-suggestion`, // ?question_id=5 
    },

    AUTH: {
        LOGIN: `${API_BASE_URL}/customer/login`,
        SIGN_UP: `${API_BASE_URL}/customer/register`,
        VERIFY_OTP: `${API_BASE_URL}/customer/verify-otp`,
        RESEND_OTP: `${API_BASE_URL}/customer/resend-otp`,
    },

    ACCOUNT: {
        MY_ACCOUNT: `${API_BASE_URL}/users`,
        MY_ACCOUNT_UPDATE: `${API_BASE_URL}/users/update`,
        MY_AVATAR_UPDATE: `${API_BASE_URL}/users/avatar`,

        MY_BUSINESS_PLAN: `${API_BASE_URL}/customer/proposals`,
        MY_PROPOSAL_DOWNLOAD: `${API_BASE_URL}/proposal/download`,  // /:proposalId
        MY_BUSINESS_PLAN_DOWNLOAD: `${API_BASE_URL}/plan/download`,  // /:proposalId
        MY_BUSINESS_PLAN_DETAILS: `${API_BASE_URL}/proposal/details`,  // /:proposalId
        MY_BUSINESS_PLAN_PRICE_DETAILS: `${API_BASE_URL}/proposal-price/:proposalId`,  // /:proposalId
        MY_BUSINESS_APPROVAL: `${API_BASE_URL}/proposal/approve`,
        MY_BUSINESS_REJECT: `${API_BASE_URL}/proposal/reject`,

        TICKET: {
            LIST: `${API_BASE_URL}/support_tickets`,
            CREATE: `${API_BASE_URL}/support_ticket/create`,
            DETAILS: `${API_BASE_URL}/support_ticket/:ticketId`,  // /:ticketId
            REPLY: `${API_BASE_URL}/ticket_replies/create`,
            CLOSE_TICKET: `${API_BASE_URL}/support_ticket/close`,
        }
    },
    CMS_PAGES: {
        CMS_LIST: `${API_BASE_URL}/cms`,
        CMS_LINK: `${API_BASE_URL}/cms/:cmsSlug`,

        CONTACT_US_SUBMIT: `${API_BASE_URL}/contact-data`,

    },

    BLOG_NEWS: {
        LIST: (countryId: string, page = 1, perPage = 12) => `${API_BASE_URL}/blog-and-news?country=${countryId}&page=${page}&per_page=${perPage}`,
        NEWS_LIST: (countryId: string, page = 1, perPage = 10) => `${API_BASE_URL}/blog-and-news?country=${countryId}&news_page=${page}&news_per_page=${perPage}`,
        NEWS_DETAILS: (slug:string, countryId:string, page = 1) => `${API_BASE_URL}/news?slug=${slug}&country=${countryId}&page=${page}`,
        BLOG_DETAILS: (slug:string, countryId:string, page = 1) => `${API_BASE_URL}/blog?slug=${slug}&country=${countryId}&page=${page}`,
    },

    MENU_PAGES: {
        PAGE_DETAILS: (countryId:string, slug:string) => `${API_BASE_URL}/get-page-details?country_id=${countryId}&slug=${slug}`,
    },
    
    MARKETER: {
        COMMISSIONS: `${API_BASE_URL}/marketer/commissions`,
        CUSTOMERS: `${API_BASE_URL}/marketer/customers`,
    },

    PAYMENTS: {
        APPLY_COUPON_CODE: `${API_BASE_URL}/validate-coupon`,
        STRIPE_INTENT: `${API_BASE_URL}/users/payment/stripe-intent`,
        STRIPE_PAYMENT_STORE: `${API_BASE_URL}/users/payment/store`,
        PAYPAL_PAYMENT_STORE: `${API_BASE_URL}/users/payment/store`,

    }
}


export const ACTIONS = {
    RESET_REDUCER: "ACTIONS/RESET_REDUCER",

    LOADER: {
        SET_FP_STATUS: "ACTIONS/LOADER/SET_FP_STATUS",
        SET_SIDEBAR: "ACTIONS/LOADER/SET_SIDEBAR"
    },

    AUTH: {
        VERIFY_OTP: "ACTIONS/AUTH/VERIFY_OTP",
        LOGOUT: "ACTIONS/AUTH/LOGOUT",
    },
    ACCOUNT: {
        MY_ACCOUNT: "ACTIONS/AUTH/MY_ACCOUNT",
        MY_ACCOUNT_UPDATE: "ACTIONS/AUTH/MY_ACCOUNT_UPDATE",
    },

    GEN_INFO: {
        COUNTRY_LIST: "ACTIONS/GEN_INFO/COUNTRY_LIST",
        SELECTED_COUNTRY: "ACTIONS/GEN_INFO/SELECTED_COUNTRY",
        MENU_LIST: "ACTIONS/GEN_INFO/MENU_LIST",
        // SET_SOCIAL_DETAILS: "ACTIONS/GEN_INFO/SET_SOCIAL_DETAILS",
    },

}

export const SAGA_ACTIONS = {
    SUBSCRIPTION: {
        PLAN_LIST: "SAGA_ACTIONS/SUBSCRIPTION/PLAN_LIST",
    },

    AUTH: {
        VERIFY_OTP: "SAGA_ACTIONS/AUTH/VERIFY_OTP",
        LOGOUT: "SAGA_ACTIONS/AUTH/LOGOUT",
    },

    ACCOUNT: {
        MY_ACCOUNT: "SAGA_ACTIONS/ACCOUNT/MY_ACCOUNT",
        MY_ACCOUNT_UPDATE: "SAGA_ACTIONS/ACCOUNT/MY_ACCOUNT_UPDATE",
        MY_BUSINESS_PLAN: "SAGA_ACTIONS/ACCOUNT/MY_BUSINESS_PLAN",
    },
}